import { createFileRoute, notFound } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { seoMeta } from "@/lib/seo/head";
import { getPost } from "@/lib/seo/blog";
import { JsonLd, articleSchema } from "@/components/seo/json-ld";

export const Route = createFileRoute("/blog/$slug")({
  loader: ({ params }) => {
    const post = getPost(params.slug);
    if (!post) throw notFound();
    return { post };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return { meta: [{ title: "Blog - LexAIPro" }] };
    return seoMeta({
      title: loaderData.post.title,
      description: loaderData.post.description,
      path: `/blog/${loaderData.post.slug}`,
      type: "article",
    });
  },
  notFoundComponent: () => (
    <div className="flex min-h-screen items-center justify-center"><p className="text-muted-foreground">Articolo non trovato.</p></div>
  ),
  errorComponent: () => (
    <div className="flex min-h-screen items-center justify-center"><p className="text-muted-foreground">Errore nel caricamento.</p></div>
  ),
  component: BlogPostPage,
});

function BlogPostPage() {
  const { post } = Route.useLoaderData();
  return (
    <>
      <JsonLd data={articleSchema({ title: post.title, description: post.description, path: `/blog/${post.slug}`, datePublished: post.datePublished, dateModified: post.dateModified })} />
      <ContentPage
        eyebrow="Articolo"
        title={post.title}
        lead={post.excerpt}
        breadcrumbs={[{name:"Home",path:"/"},{name:"Blog",path:"/blog"},{name:post.title,path:`/blog/${post.slug}`}]}
        sections={post.sections}
        cta={{ label: "Prova LexAIPro", to: "/signup" }}
        updated={new Date(post.dateModified ?? post.datePublished).toLocaleDateString("it-IT")}
      />
    </>
  );
}
